export default __webpack_public_path__ + "static/media/w2_blue.20b485ab.svg";